module.exports = __webpack_public_path__ + "static/img/23-realestatefinance.ff008ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-realestatefinance.png
// module id = NZJK
// module chunks = 1